/**
 * Constants to determine the action
 * types at init and user information level.
 * */
export const Types = {
    NETWORK_ERROR: "NETWORK_ERROR",
    NETWORK_START: "NETWORK_START",
    NETWORK_STOP: "NETWORK_STOP",
    SIGN_IN: "SIGN_IN",
    SIGN_OUT: "SIGN_OUT",
    ADD_USER_RIGHTS: "ADD_USER_RIGHTS",
};
